import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  padding: 20px;

  cursor: ${props => (props.loading ? 'wait' : 'default')};

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 400px;
  background: #ffffff;
  padding: 40px 32px;
  position: relative;

  @media (max-width: 480px) {
    max-width: 100%;
    padding: 32px 24px;
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  img {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;

    @media (max-width: 480px) {
      width: 100px;
      height: 100px;
      margin-bottom: 20px;
    }
  }

  form {
    width: 100%;
    margin-top: 20px;

    h1 {
      color: ${props => `${props.color || '#01579b'}`};
      margin-bottom: 24px;
      font-size: 28px;
      font-weight: 600;

      @media (max-width: 480px) {
        font-size: 24px;
        margin-bottom: 20px;
      }
    }

    button {
      background: ${props => `${props.color || '#01579b'}`};
      height: 48px;
      border-radius: 12px;
      border: 0;
      padding: 0 16px;
      color: #ffffff;
      width: 100%;
      font-weight: 600;
      font-size: 16px;
      margin: 16px 0;
      transition: all 0.2s ease-in-out;
      box-shadow: 0 4px 12px rgba(1, 87, 155, 0.3);

      display: flex;
      align-items: center;
      justify-content: center;

      &:hover:not(:disabled) {
        opacity: 0.9;
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(1, 87, 155, 0.4);
      }

      &:active:not(:disabled) {
        transform: translateY(0);
      }

      &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
      }

      @media (max-width: 480px) {
        height: 44px;
        font-size: 15px;
      }
    }
  }
`;

export const Footer = styled.footer`
  margin-top: 24px;
  color: #666666;
  font-size: 12px;
  text-align: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;

    strong {
      font-size: 12px;
      font-weight: 500;
    }

    svg {
      margin-right: 4px;
      font-size: 10px;
    }
  }

  span {
    font-size: 11px;
    opacity: 0.8;
  }

  @media (max-width: 480px) {
    font-size: 11px;

    div strong {
      font-size: 11px;
    }

    span {
      font-size: 10px;
    }
  }
`;
